import React, { useState, useEffect, useRef } from 'react'
import './Skills.css'
import { MdOutlineExpandMore, MdOutlineExpandLess } from "react-icons/md";

import img1 from './../images/1.jpeg'
import img2 from './../images/2.jpeg'
import img3 from './../images/3.jpeg'
import img4 from './../images/4.jpeg'
import img5 from './../images/5.jpeg'
import img6 from './../images/6.jpeg'
import img8 from './../images/8.jpeg'
import img10 from './../images/10.jpeg'
import img11 from './../images/11.jpeg'
import img12 from './../images/12.jpeg'
import img13 from './../images/13.jpeg'
import img14 from './../images/14.jpeg'
import img15 from './../images/15.jpeg'
import img16 from './../images/16.jpeg'
import img17 from './../images/17.jpeg'
import img18 from './../images/18.jpeg'
import img19 from './../images/19.jpeg'
import img20 from './../images/20.jpeg'
import img21 from './../images/21.jpeg'
import img22 from './../images/22.jpeg'
import img23 from './../images/23.jpeg'
import img24 from './../images/24.jpeg'
import img25 from './../images/25.jpeg'
import img26 from './../images/26.jpeg'
import img27 from './../images/27.jpeg'
import img28 from './../images/28.jpeg'
import img29 from './../images/29.jpeg'
import img30 from './../images/30.jpeg'
import img31 from './../images/31.jpeg'
import img32 from './../images/32.jpeg'
import img33 from './../images/33.jpeg'
import img34 from './../images/34.jpeg'
import img35 from './../images/35.jpeg'
import img36 from './../images/36.jpeg'
import img37 from './../images/37.jpeg'
import img38 from './../images/38.jpeg'
import img39 from './../images/39.jpeg'
import img40 from './../images/40.jpeg'
import img41 from './../images/41.jpeg'
import img42 from './../images/42.jpeg'
import img43 from './../images/43.jpeg'
import img44 from './../images/44.jpeg'
import img45 from './../images/45.jpeg'
import img46 from './../images/46.jpeg'
import img47 from './../images/47.jpeg'
import img48 from './../images/48.jpeg'
import img49 from './../images/49.jpeg'
import img50 from './../images/50.jpeg'
import img51 from './../images/51.jpeg'
import img52 from './../images/52.jpeg'
import img53 from './../images/53.jpeg'
import img54 from './../images/54.jpeg'
import img55 from './../images/55.jpeg'
import img56 from './../images/56.jpeg'
import img57 from './../images/57.jpeg'
import img58 from './../images/58.jpeg'
import img59 from './../images/59.jpeg'
import img60 from './../images/60.jpeg'
import img61 from './../images/61.jpeg'
import img62 from './../images/62.jpeg'
import img67 from './../images/67.jpg'
import img68 from './../images/68.jpg'
import img69 from './../images/69.jpg'
import img70 from './../images/70.jpg'
import img71 from './../images/71.jpg'
import img72 from './../images/72.jpg'
import img73 from './../images/73.jpg'
import img74 from './../images/74.jpg'
import img75 from './../images/75.jpg'
import img76 from './../images/76.jpg'
import img77 from './../images/77.jpg'
import img78 from './../images/78.jpg'
import img79 from './../images/79.jpg'
import img80 from './../images/80.jpg'
import img81 from './../images/81.jpg'

import BeforeAfter from './BeforeAfter'
import ProjectCard from './ProjectCard'
import BeforeAfter2 from './BeforeAfter2'
import BeforeAfter3 from './BeforeAfter3'
import BeforeAfter4 from './BeforeAfter4'





function reveal() {
  var reveals = document.querySelectorAll(".marquee");
  for (var i = 0; i < reveals.length; i++) {
    var windowHeight = window.innerHeight;
    var elementTop = reveals[i].getBoundingClientRect().top;
    var elementVisible = 150;
    if (elementTop < windowHeight - elementVisible) {
      reveals[i].classList.add("active3");
    } else {
      reveals[i].classList.remove("active3");
    }
  }
}
function reveal2() {
  var reveals = document.querySelectorAll(".marquee2");
  for (var i = 0; i < reveals.length; i++) {
    var windowHeight = window.innerHeight;
    var elementTop = reveals[i].getBoundingClientRect().top;
    var elementVisible = 150;
    if (elementTop < windowHeight - elementVisible) {
      reveals[i].classList.add("active3");
    } else {
      reveals[i].classList.remove("active3");
    }
  }
}




export const Skills = (props) => {
  const [showAll, setShowAll] = useState(false);
  const carouselRef = useRef(null);

  // All gallery items
  const rawProjectItems = [
    { type: 'ProjectCard', props: { images: [img1, img2, img3, img4, img5, img6], title: "Rénovation Pavillon H au CHU Lyon Edouard Herriot" } },
    { type: 'BeforeAfter2', props: { i1: img10, i2: img11, i3: img12, title: "Renovation Salle de Bain" } },
    { type: 'BeforeAfter', props: { i1: img55, i2: img56, title: "Ravalement de façade" } },
    { type: 'ProjectCard', props: { images: [img13, img14, img15], title: "Ravalement de façade" } },
    { type: 'BeforeAfter', props: { i1: img16, i2: img17, title: "Renovation Salle de Bain" } },
    { type: 'BeforeAfter3', props: { i1: img22, i2: img18, i3: img19, i4: img20, i5: img21, title: "Rénovation des parties communes d'un immeuble" } },
    { type: 'ProjectCard', props: { images: [img23, img24, img25, img26], title: "Renovation Salle de Bain" } },
    { type: 'BeforeAfter2', props: { i1: img27, i2: img28, i3: img29, title: "Rénovation des parties communes d'un immeuble" } },
    { type: 'ProjectCard', props: { images: [img30, img31, img32, img33, img34], title: "Renovation Salle de Bain" } },
    { type: 'ProjectCard', props: { images: [img35, img36, img37, img38, img39, img40, img41, img42], title: "Rénovation de charpente et aménagement sous combles" } },
    { type: 'ProjectCard', props: { images: [img72, img73, img74, img75], title: "Toiture" } },
    { type: 'ProjectCard', props: { images: [img43, img44], title: "Rénovation de cuisune moderne" } },
    { type: 'ProjectCard', props: { images: [img45, img46, img47, img48], title: "Installation d'un filet catamaran" } },
    { type: 'ProjectCard', props: { images: [img67, img68, img69, img70, img71], title: "Maçonnerie" } },
    { type: 'ProjectCard', props: { images: [img76, img77, img78, img79, img80, img81], title: "Placo" } },
    { type: 'ProjectCard', props: { images: [img49], title: "Rénovation des parties communes d'un immeuble" } },
    { type: 'BeforeAfter3', props: { i1: img50, i2: img51, i3: img52, i4: img53, i5: img54, title: "Rénovation des parties communes d'un immeuble" } },
    { type: 'ProjectCard', props: { images: [img57, img58, img59, img60, img61, img62], title: "Amenagement extérieur" } },
  ];

  // Remove duplicates by title (keep only one item for each project title)
  const projectItems = rawProjectItems.reduce((acc, item) => {
    const exists = acc.find((i) => i.props.title === item.props.title);
    if (!exists) {
      acc.push(item);
    }
    return acc;
  }, []);

  const visibleItems = showAll ? projectItems : projectItems.slice(0, 4);

  const handleCarouselScroll = (direction) => {
    if (!carouselRef.current) return;
    const container = carouselRef.current;
    const scrollAmount = container.clientWidth * 0.8;
    container.scrollBy({
      left: direction === 'left' ? -scrollAmount : scrollAmount,
      behavior: 'smooth',
    });
  };

  // Activate auto-scroll animation on mount
  useEffect(() => {
    const reveal = () => {
      document.querySelectorAll(".marquee").forEach(el => {
        const top = el.getBoundingClientRect().top;
        if (top < window.innerHeight - 150) {
          el.classList.add("active3");
        } else {
          el.classList.remove("active3");
        }
      });
    };
    window.addEventListener("scroll", reveal);
    reveal(); // Call once on mount
    return () => window.removeEventListener("scroll", reveal);
  }, []);

  // Duplicate items multiple times for seamless infinite scroll
  const duplicatedItems = [...projectItems, ...projectItems, ...projectItems];

  return (
    <>
    <div id="Galerie" className="text-center">
      <br/>
    <div className="">
      <div className="section-title">
        <h2>Galerie</h2>
      </div>

    <div id="skills"   className='all2   position-relative d_non  ' style={{bottom:'30px',boxSizing:'unset'}}>
                  <div className="container pt-4">
    <div className="pt-2 padding2  position-relative " style={{bottom:'8px'}} >

  <div  className=" marg_left none3  pb-4">
    <div className="skil_cont g-5 " style={{cursor:'pointer'}}>
      <button
        type="button"
        className="gallery-arrow gallery-arrow-left"
        onClick={() => handleCarouselScroll('left')}
      >
        ‹
      </button>
      <div className="scrl" ref={carouselRef}>
        <div className="marquee-container">
          <div className="marquee">
            {duplicatedItems.map((item, idx) => (
              <span className="skil" key={idx}>
                {item.type === 'ProjectCard' && <ProjectCard {...item.props} />}
                {item.type === 'BeforeAfter' && <BeforeAfter {...item.props} />}
                {item.type === 'BeforeAfter2' && <BeforeAfter2 {...item.props} />}
                {item.type === 'BeforeAfter3' && <BeforeAfter3 {...item.props} />}
                {item.type === 'BeforeAfter4' && <BeforeAfter4 {...item.props} />}
              </span>
            ))}
          </div>
        </div>
      </div>
      <button
        type="button"
        className="gallery-arrow gallery-arrow-right"
        onClick={() => handleCarouselScroll('right')}
      >
        ›
      </button>
    </div>
    </div>
    </div>

    </div>
    </div>
    </div>

    <div className="marg_left yup d_yes">
      <div className='row'>
        <div className="col-sm-6 col-md-6 mb-4 nin">
          <div className="skills-container">
            {visibleItems.map((item, idx) => (
              <span key={idx} className="skil">
                {item.type === 'ProjectCard' && <ProjectCard {...item.props} />}
                {item.type === 'BeforeAfter' && <BeforeAfter {...item.props} />}
                {item.type === 'BeforeAfter2' && <BeforeAfter2 {...item.props} />}
                {item.type === 'BeforeAfter3' && <BeforeAfter3 {...item.props} />}
                {item.type === 'BeforeAfter4' && <BeforeAfter4 {...item.props} />}
              </span>
            ))}
          </div>

          <div className="show-more-container mt-4">
            <button
              className="show-more-btn"
              onClick={() => setShowAll(!showAll)}
            >
              {showAll ? (
                <>
                  <MdOutlineExpandLess className="icon-animated up" />
                  <br />
                  Afficher moins
                </>
              ) : (
                <>
                  Afficher plus
                  <br />
                  <MdOutlineExpandMore className="icon-animated down" />
                </>
              )}
            </button>

          </div>
          <br />
          <br />

        </div>
      </div>
    </div>
    </div>
    </>
  )
}

export default Skills
